import gql from 'graphql-tag';

import formTemplateFragment from '~/shared/graphql-queries/form-templates/form-template-fragment';

export default gql`
  mutation updateByIdFormTemplateMutation(
    $_id: MongoID!
    $record: UpdateByIdFormTemplateInput!
  ) {
    updateByIdFormTemplateMutation(_id: $_id, record: $record) {
      recordId
      record {
        ...FormTemplateFragment
      }
      message
      title
    }
  }
  ${formTemplateFragment}
`;
